@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  /* Background - warmes Cremeweiß/Off-White */
  --background-50: 0.99 0.005 80;
  --background-100: 0.97 0.008 78;
  --background-200: 0.94 0.01 76;
  --background-300: 0.90 0.012 74;
  --background-400: 0.86 0.015 72;
  --background-500: 0.82 0.018 70;
  --background-600: 0.76 0.015 68;
  --background-700: 0.68 0.012 66;
  --background-800: 0.58 0.01 64;
  --background-900: 0.48 0.008 62;
  --background-950: 0.38 0.006 60;

  /* Primary - warmes Taupe/Steingrau */
  --primary-50: 0.94 0.01 70;
  --primary-100: 0.88 0.015 65;
  --primary-200: 0.80 0.02 60;
  --primary-300: 0.72 0.025 55;
  --primary-400: 0.64 0.03 50;
  --primary-500: 0.56 0.035 45;
  --primary-600: 0.48 0.04 40;
  --primary-700: 0.40 0.04 35;
  --primary-800: 0.32 0.035 30;
  --primary-900: 0.24 0.03 25;
  --primary-950: 0.16 0.025 20;

  /* Accent - Salbei/Eukalyptusgrün */
  --accent-50: 0.96 0.02 150;
  --accent-100: 0.92 0.04 145;
  --accent-200: 0.86 0.06 140;
  --accent-300: 0.78 0.08 135;
  --accent-400: 0.70 0.10 130;
  --accent-500: 0.62 0.10 125;
  --accent-600: 0.54 0.09 120;
  --accent-700: 0.46 0.08 115;
  --accent-800: 0.38 0.07 110;
  --accent-900: 0.30 0.06 105;
  --accent-950: 0.22 0.05 100;

  /* Secondary - Altrosa/Blütennuance */
  --secondary-50: 0.95 0.02 20;
  --secondary-100: 0.90 0.03 18;
  --secondary-200: 0.84 0.04 16;
  --secondary-300: 0.76 0.05 15;
  --secondary-400: 0.68 0.06 14;
  --secondary-500: 0.60 0.06 13;
  --secondary-600: 0.52 0.05 12;
  --secondary-700: 0.44 0.04 11;
  --secondary-800: 0.36 0.03 10;
  --secondary-900: 0.28 0.025 9;
  --secondary-950: 0.20 0.02 8;

  /* Foreground - dunkles Anthrazit */
  --foreground-50: 0.94 0.01 250;
  --foreground-100: 0.86 0.015 245;
  --foreground-200: 0.76 0.02 240;
  --foreground-300: 0.66 0.025 235;
  --foreground-400: 0.56 0.03 230;
  --foreground-500: 0.46 0.035 225;
  --foreground-600: 0.36 0.04 220;
  --foreground-700: 0.28 0.035 215;
  --foreground-800: 0.20 0.03 210;
  --foreground-900: 0.14 0.025 205;
  --foreground-950: 0.08 0.02 200;

  /* Typography — lokal-sichere System-Fonts, keine externen CDN-Ladungen */
  --font-heading: 'Georgia', 'Times New Roman', 'Palatino Linotype', serif;
  --font-body: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  --font-label: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

/* Honeypot field - versteckt via CSS, nicht inline */
.hp-field {
  position: absolute;
  left: -9999px;
  top: -9999px;
  opacity: 0;
  pointer-events: none;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: var(--font-body);
  color: oklch(var(--foreground-900));
  background-color: oklch(var(--background-50));
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Elegant heading styles */
h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-heading);
  color: oklch(var(--foreground-950));
  font-weight: 500;
  letter-spacing: -0.01em;
}

/* Focus visible for accessibility */
*:focus-visible {
  outline: 2px solid oklch(var(--accent-400));
  outline-offset: 2px;
}

/* Selection color */
::selection {
  background-color: oklch(var(--secondary-200));
  color: oklch(var(--foreground-950));
}